import _regeneratorRuntime from "/codebuild/output/src1688139503/src/cocoo_school_admin/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/codebuild/output/src1688139503/src/cocoo_school_admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import { ref, computed, watch } from "vue";
import { useRoute, useRouter } from "vue-router/composables";
import { getData, deleteData } from "@/services/axios";
import { useStore } from "vue2-helpers/vuex";
import moment from "moment";
import LoadingMessage from "@/components/common/LoadingMessage.vue";
import UrlToLink from "@/components/common/UrlToLink.vue";
import ConfirmSlotModal from "@/components/common/ConfirmSlotModal.vue";
import MessageModal from "@/components/common/MessageModal.vue";
import ForumArticle from "@/components/forums/ForumArticle.vue";
import ForumDetailComment from "@/components/forums/ForumDetailComment.vue";
export default {
  __name: 'ForumDetail',
  setup: function setup(__props) {
    // @ts-check
    var route = useRoute();
    var router = useRouter();
    var store = useStore();
    var me = computed(function () {
      return store.state.me;
    });
    var isLoading = ref(true);
    var s3AttachedPath = ref("");
    /** @type {Ref<Object<string, any>>} */

    var forumData = ref({});
    var forumList = ref([]);

    var setData = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var data;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                isLoading.value = true;
                _context.next = 4;
                return getData(["school_forums/".concat(route.params.id), "school_forums?from=2023-04-01&to=2024-03-31&exclude=".concat(route.params.id, "&limit=10")]);

              case 4:
                data = _context.sent;
                forumData.value = data[0].items;
                forumList.value = data[1].items;
                s3AttachedPath.value = forumData.value.attachment[0] ? forumData.value.attachment[0].object_key : "";
                _context.next = 13;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context["catch"](0);
                console.log(_context.t0);

              case 13:
                _context.prev = 13;
                isLoading.value = false;
                return _context.finish(13);

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 10, 13, 16]]);
      }));

      return function setData() {
        return _ref.apply(this, arguments);
      };
    }();

    var isShowConfirmModal = ref(false);
    var isShowCompleteModal = ref(false);

    var handleForumDelete = function handleForumDelete() {
      isShowConfirmModal.value = true;
    };

    var hideConfirmModal = function hideConfirmModal() {
      isShowConfirmModal.value = false;
    };

    var deleteForum = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                isLoading.value = true;
                _context2.next = 4;
                return deleteData("school_forums/".concat(route.params.id));

              case 4:
                store.dispatch("commitModalMessage", {
                  message: "記事が削除されました",
                  title: "削除完了"
                });
                isLoading.value = false;
                isShowConfirmModal.value = false;
                isShowCompleteModal.value = true;
                _context2.next = 15;
                break;

              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2["catch"](0);
                console.log(_context2.t0);
                isLoading.value = false;
                isShowConfirmModal.value = false;

              case 15:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[0, 10]]);
      }));

      return function deleteForum() {
        return _ref2.apply(this, arguments);
      };
    }();

    var completeDelete = function completeDelete() {
      isShowCompleteModal.value = false;
      router.push({
        name: "forums"
      });
    }; // created


    setData();
    watch(function () {
      return route.params.id;
    }, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return setData();

            case 2:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    })));
    return {
      __sfc: true,
      route: route,
      router: router,
      store: store,
      me: me,
      isLoading: isLoading,
      s3AttachedPath: s3AttachedPath,
      forumData: forumData,
      forumList: forumList,
      setData: setData,
      isShowConfirmModal: isShowConfirmModal,
      isShowCompleteModal: isShowCompleteModal,
      handleForumDelete: handleForumDelete,
      hideConfirmModal: hideConfirmModal,
      deleteForum: deleteForum,
      completeDelete: completeDelete,
      moment: moment,
      LoadingMessage: LoadingMessage,
      UrlToLink: UrlToLink,
      ConfirmSlotModal: ConfirmSlotModal,
      MessageModal: MessageModal,
      ForumArticle: ForumArticle,
      ForumDetailComment: ForumDetailComment
    };
  }
};